import Toast from '../../component/toastify/Index.jsx';
import axios from '../../axios/interceptor.js';

export const getCustomerIntegration = async () => {
    try {
        const response = await axios.get('/customer/integration/get')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const addCustomerIntegration = async (provider, apiKey, apiClient, apiSecret) => {
    try {
        const response = await axios.post('/customer/integration/create', { provider: provider, apiKey: apiKey, apiClient: apiClient, apiSecret: apiSecret })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateCustomerIntegration = async (provider, updates) => {
    try {
        const response = await axios.put(`/customer/integration/update`, { provider: provider, ...updates })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteCustomerIntegration = async (provider) => {
    try {
        const response = await axios.put(`/customer/integration/delete`, { provider: provider })
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const createWisoIntegration = async (ownershipId) => {
    try {
        const response = await axios.post("customer/integration/wiso-create", {
            ownershipId,
        });
        if (response?.data?.isSuccess) {
            return true;
        }
        Toast(response?.data?.message, "error");
        return false;
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
        return false;
    }
}

export const initiateLexwareAuth = async () => {
  try {
    const res = await axios.get('customer/integration/lexware/initiate');
    return res.data;
  } catch (err) {
    return { isSuccess: false, message: err.message };
  }
};

